import { createAsyncThunk } from '@reduxjs/toolkit';
import { getZendeskPodDataContactId } from 'services/pod';
import { IPodData } from 'services/pod/types';
import { convertSimplifiedToPodData } from 'store/pod/helpers';

interface IProps {
  psaId: number;
  contactId: number;
}

export const ThunkGetZendeskPodDataByContactId = createAsyncThunk<IPodData, IProps>(
  'pod/getZendeskPodDataContactId',
  async ({ psaId, contactId }) =>
    getZendeskPodDataContactId(psaId, contactId)
      .then(r => r.data)
      .then(data => convertSimplifiedToPodData(data)),
);
